
var EARTH_RADIUS = 6371 * 1000;

export class Map{
    constructor(...params ){
        var _markerManager = new MarkerManager(); 


        Object.defineProperty(this,'markerManager',{
            get : ()=>_markerManager,
            enumerable : false
        });

        this.init(...params);



    }

    // ==========
    // private
    // ----------
    getElement(){ return this.element }

    setMap(m){ this.map = m }

    getMap(){ return this.map }

    init(...params){
        var map = this.createMap(...params);
        this.setMap(map);
    }

    getMarkerManager(){ return this.markerManager }


    // ==========
    // overalod 
    // ----------

    createMap(){}

    addMarker(){}

    //===========
    // static
    // -----------
    static computeHaversineDistance(lat1, lon1, lat2 ,lon2){
        var dLat = Math.toRadians(lat2 - lat1);
        var dLon = Math.toRadians(lon2 - lon1) * Math.cos(Math.toRadians((lat1+lat2) / 2));
        return EARTH_RADIUS * Math.sqrt(dLat * dLat + dLon * dLon)
    }



    static computeBounds(markers){
        var east,
            west, 
            north,
            south
        ; 
        markers.forEach(function(marker){
            var position = marker.getPosition();
            var lat = position.lat();
            var lng = position.lng();
            if (!north || (lat> north)) north = lat;
            if (!south || (lat < south)) south = lat; 
            if (!east ||  (lng > east )) east = lng;
            if (!west || (lng < west )) west = lng;
        });
        return {
            east, west, north, south
        }        
    }
}


class MarkerManager{
    constructor(){
        var _markers = [];

        Object.defineProperty(this,'getMarkerIterator',{
            value : ()=>_markers[Symbol.iterator]()
        });

        Object.defineProperty(this,'addMarker',{
            value : (marker)=>{ _markers.push(marker) }
        })

        Object.defineProperty(this,'clear',{
            value : ()=>{ _markers = [] }  
        });

        Object.defineProperty(this,'getBounds',{
            value : ()=>Map.computeBounds(_markers)
            
        });

        Object.defineProperty(this,'markers',{
            get : function(){ return _markers }
        })
    }

    // ==========
    // public 
    // ----------
    getMarkers(){ return this.markers; }


    updateMarkers(fn){
        var it = this.getMarkerIterator();
        var n;
        while(!((n = it.next()).done)){
            var marker = n.value;
            fn(marker);
        }
    }
}